export default __webpack_public_path__ + "static/widowmakerV2-d6fd7b15c50ff9a54c9970b4ee59b0ef.png";